module.exports = __webpack_public_path__ + "img/humos.ea27fd28.png";